import { WaasImpl } from "./waas.js";
export function StaticImplements() {
    return (constructor) => {
        return constructor;
    };
}
export function RequireAuth(target, propertyKey, descriptor) {
    const originalMethod = descriptor.value;
    descriptor.value = async function (...args) {
        await WaasImpl.maybeRefreshAuthToken();
        return await originalMethod.apply(this, args);
    };
}
